//
// Module for the Withholdings Index view
//
rs.module("participant/benefit/withholdings/index",

    [
        "controls/data/grid",
        "controls/components/event-banner"
    ],

    function (gridModule, eventBanner) {

        var _executeSelectionChanged;

        // Initialize the module
        function initialize(lrsGridApi, jsSelectors, cssClasses, ajaxUrls) {

            var filter = $.js(jsSelectors.filter);
            var currentWithholdingRadioGrouping = filter.js(jsSelectors.currentWithholdingIndicators);
            var loadingSpinner = filter.js(jsSelectors.loadingSpinner);

            var addButton = $.js(jsSelectors.addButton);

            var details = $.js(jsSelectors.withholdingDetailCard);

            // Hook up click event on the radio buttons to reload the grid data via ajax
            currentWithholdingRadioGrouping.find("input").on('click', function () {

                loadingSpinner.show();

                // Store current grid selection
                var currentValues = lrsGridApi.selectedValues;

                // Update grid, set row selection, update detail of selected row
                gridModule.update(
                    ajaxUrls.getGridData,
                    { showAll: this.value },
                    lrsGridApi.agGridApi,
                    function done(gridUpdate) {

                        // Before hiding spinner, set the withholding detail
                        if (lrsGridApi.agGridApi.getDisplayedRowCount() > 0) {
                            details.toggleClass(cssClasses.hidden, false);

                            if (currentValues.length == 1) {
                                lrsGridApi.selectedValues = currentValues[0];
                            }

                            // If there wasn't a previously selected row or if the row doesn't exist, 
                            // default to first row in the grid
                            if (lrsGridApi.selectedValues.length == 0) {
                                lrsGridApi.selectFirstRow();
                            }

                        } else {
                            details.toggleClass(cssClasses.hidden, true);
                        }

                        loadingSpinner.hide();

                        // Update the Add button url to include the current selection
                        addButton.attr('href', gridUpdate.context.addUrl);
                    }
                );
            });

            // On grid selection change, update withholding details
            lrsGridApi.selectionChanged(function (values, rows) {
                if (_executeSelectionChanged && values.length > 0) {
                    eventBanner.removeInformationalMessages();
                    refreshWithholdingDetails(values[0], currentWithholdingRadioGrouping.find("input:checked").val());
                }

                _executeSelectionChanged = true;
            });

            // Update the withholding details based on given key
            function refreshWithholdingDetails(withholdingKey, showAll) {
                $.get(ajaxUrls.updateWithholdingDetail, { withholdingKey: withholdingKey, showAll: showAll }).done(function (result) {
                    details.html(result);
                });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);